<template>
    <div class="sidebar-detail">
        <!-- :title="`${detailInfo.name || '----' } ${qrCode}`" -->
        <detail-header
            v-if="detailInfo"
            title="Progeny"
            @refreshDetailPage="refreshDetailPage"
            @closeDetailPage="closeDetailPage"
        />

        <div>
            <p class="detail-title">Details</p>
            <div>
                <table class="recording-detail-table">
                    <tr>
                        <td>Id</td>
                        <td>{{ detailInfo.id }}</td>
                    </tr>
                    <tr>
                        <td>Progeny Code</td>
                        <td>{{ detailInfo.code }}</td>
                    </tr>
                    <tr>
                        <td>Female Palm</td>
                        <td>
                            <mpob-palm-format :cell="detailInfo.maternalPalm" />
                        </td>
                    </tr>
                    <tr>
                        <td>Male Palm</td>
                        <td><mpob-palm-format :cell="detailInfo.paternalPalm" /></td>
                    </tr>
                    <tr>
                        <td>Cross Type</td>
                        <td>{{ (detailInfo.crossType||{}).name || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Generation</td>
                        <td>{{ detailInfo.generation || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Material</td>
                        <td>{{ (detailInfo.material||{}).name || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Mating Design</td>
                        <td>{{ (detailInfo.matingDesign||{}).name || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Is Standard Cross</td>
                        <td>{{ $_converBoolean(detailInfo.isStandard) || '-' }}</td>
                    </tr>
                    <tr>
                        <td>Is Cloned</td>
                        <td>{{ $_converBoolean(detailInfo.isCloned) || '-' }}</td>
                    </tr>
                    <tr>
                        <td>Is Active</td>
                        <td>{{ $_converBoolean(detailInfo.isActive) || '-' }}</td>
                    </tr>
                    <tr>
                        <td class="table-section" colspan="2">Germplasm</td>
                    </tr>
                    <tr>
                        <td>Accession Number</td>
                        <td>{{ (detailInfo.germplasm||{}).accessionNumber || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Country</td>
                        <td>{{ ((detailInfo.germplasm||{}).country||{}).name || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Species</td>
                        <td>{{ ((detailInfo.germplasm||{}).species||{}).name || "-" }}</td>
                    </tr>
                </table>
            </div>

            <p class="detail-title detail-title-pd">Date Time</p>
            <div class="user-datetime-container">
                <table>
                    <tr>
                        <td>Modified</td>
                        <td>{{ $_getDateTimeFormat(detailInfo.lastModificationTime) }} {{ $t('detail.by') }} {{ (detailInfo.lastModifierUser||{}).userName || '-' }}</td>
                    </tr>
                    <tr>
                        <td>Created</td>
                        <td>{{ $_getDateTimeFormat(detailInfo.creationTime) }} {{ $t('detail.by') }} {{ (detailInfo.creatorUser||{}).userName || '-' }}</td>
                    </tr>
                </table>
            </div>

            <p class="detail-title detail-title-pd">Trial Information</p>
            <trial-simple-table :id="detailInfo.id" />
        </div>
    </div>
</template>

<script>
import DetailHeader from "./DetailHeader";
import { progenyGet } from "@/api/progeny";
import MPOBPalmFormat from "@/components/Progeny/MPOBPalmFormat";
import TrialSimpleTable from "@/components/Trial/TrialSimpleTable.vue";

export default {
    components: {
        "detail-header": DetailHeader,
        "mpob-palm-format": MPOBPalmFormat,
        "trial-simple-table": TrialSimpleTable
    },
    props: {
        infoSidebarId: {
            type: Number | String
        }
    },
    data() {
        return {
            detailInfo: null
        };
    },
    watch: {
        infoSidebarId: {
            immediate: true,
            handler() {
                this.getDetails();
            },
        }
    },
    methods: {
        async getDetails() {
            if (this.infoSidebarId) {
                var res = await progenyGet({ Id: this.infoSidebarId });
                if (res) {
                    this.detailInfo = res;
                }
            }
        },
        refreshDetailPage() {
            this.getDetails();
        },
        closeDetailPage() {
            this.$store.dispatch("info_sidebar/setInfoSidebar");
        }
    }
};
</script>

<style scoped>
.stepper-container {
    padding: var(--space-16) 0;
}
</style>


// WEBPACK FOOTER //
// src/components/SidebarDetail/ProgenySidebar.vue